import { TableBodyCell, Avatar } from '@pocketlaw/tetris';
export function BadgeCell(props) {
    const { children, appearance } = props;
    return (<TableBodyCell headers="filesystemtable-name">
      <Avatar size="md" appearance={appearance}>
        {children}
      </Avatar>
    </TableBodyCell>);
}
